import { render, staticRenderFns } from "./OrderNumber.vue?vue&type=template&id=2b6ac587&"
import script from "./OrderNumber.vue?vue&type=script&lang=ts&"
export * from "./OrderNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports